<template>
	<div class="mainBox">
		<div class="topNav">
			<van-nav-bar safe-area-inset-top :placeholder="true" :fixed="true" title="添加当日记事" left-text="返回" left-arrow @click-left="goBack">

			</van-nav-bar>
		</div>
		<van-form @submit="onSubmit">
			<van-field v-model="today" readonly name="today" label="时间" placeholder="时间" />
			<van-field readonly clickable
				:value="weather"
				name="weather" 
				label="天气" 
				placeholder="请选择天气"
				:rules="[{ required: true, message: '' }]"
				@click="showWeatherPicker = true" />
			<van-popup v-model="showWeatherPicker" position="bottom">
				<van-picker show-toolbar :columns="weatherList" @confirm="onConfirm" @cancel="showWeatherPicker = false" />
			</van-popup>
			<van-field
					v-model="temperature"
					name="temperature"
					label="温度"
					placeholder="请输入温度"
				/>
			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">保存</van-button>
			</div>
		</van-form>
	</div>
</template>
<script>
	import common from '../../utils/common';
	import { Notify } from 'vant';
	import {getNowDate} from "../../utils/date"
	import { saveNote } from '@/api/notes';
	
	export default {
		name: 'notesDetail',
		data() {
			return {
				project: {},
				user: {},
				today: "",
				weather: '',
				weatherList: ['晴','多云','阴','阵雨','小雨','中雨','大雨','小雪','中雪','大雪'],
				showWeatherPicker: false,
				temperature: "",
			}
		},
		mounted() {
			this.today = getNowDate();
			this.project = common.getProject();
			this.user = common.getUser();
		},
		methods: {
			goBack() {
				this.$router.push({
					name: 'notesList'
				});
			},
			onConfirm(value) {
			    this.weather = value;
			    this.showWeatherPicker = false;
			},
			onSubmit() {
				if (!common.hasPermision("noteList:add")) {
					Notify({ type: 'danger', message: "无操作权限" });
					return;
				}
				const param = {
					workNo: this.project.workNo,
					weather: this.weather,
					temperature: this.temperature,
					recTime: this.today,
					recMan: this.user.username,
				}
				saveNote(param).then(response => {
					if(response.data.messageCode === "SUCCESS") {
						Notify({ type: 'success', message: '操作成功' });
						this.goBack()
					} else {
						Notify({ type: 'danger', message: response.data.resultMessage });
					}
				})
			},
		}
	}
</script>
<style lang="scss" src="@/assets/sass/common.scss"></style>
<style lang="scss" scoped>
	.mainBox {
		height: 100%;
		background-color: #ffffff;
	}
</style>
